document.addEventListener("DOMContentLoaded", function () {
  const modalTriggers = document.querySelectorAll(".c-amilikit-details__modal-trigger");
  const modals = document.querySelectorAll(".c-amilikit-details__modal");

  modalTriggers.forEach(function (trigger) {
    trigger.addEventListener("click", function (e) {
      e.preventDefault();
      const modalId = this.getAttribute("data-modal-trigger");
      const modal = document.querySelector(`[data-modal-id="${modalId}"]`);

      if (modal) {
        modal.classList.add("active");
        document.body.style.overflow = "hidden";
      }
    });
  });

  modals.forEach(function (modal) {
    const closeBtn = modal.querySelector(".c-amilikit-details__modal-close");
    const overlay = modal.querySelector(".c-amilikit-details__modal-overlay");

    function closeModal() {
      modal.classList.remove("active");
      document.body.style.overflow = "";
    }

    if (closeBtn) {
      closeBtn.addEventListener("click", closeModal);
    }

    if (overlay) {
      overlay.addEventListener("click", closeModal);
    }

    // ESCキーで閉じる
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && modal.classList.contains("active")) {
        closeModal();
      }
    });
  });
});
